import {SollapayLogomarkIllustration} from '../../illustrations';

import type {FC} from 'react';

export const LoginBackgroundSvg: FC = () => {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      <SollapayLogomarkIllustration className="absolute inset-y-0 -end-24 h-full w-auto scale-125 text-background-quaternary" />
      <div className="absolute inset-0 bg-linear-to-r from-transparent from-40% to-background-surface to-80%" />
    </div>
  );
};
